import { useExperiments } from 'state/experiments';
import { RunningExperiments } from 'state/experiments';

export const useModifierRedesignExperiment = () => {
  const { variant } = useExperiments();

  return variant(RunningExperiments.ModifierRedesignPhaseOne, 'treatment');
};
